import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";
import { Link } from 'react-router-dom';
import herobg from '../assets/bg2.jpeg';
import { projects } from '../data/Projects';


function Projects() {
  

  return (
    <div>
      <section
        className="relative w-full h-[30vh] md:h-[40vh] bg-cover bg-center"
        style={{ backgroundImage: `url(${herobg})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-75"></div>
        <div className="relative z-10 flex flex-col items-start justify-center h-full px-6 md:px-12 max-w-6xl mx-auto text-white">
          <h1 className="text-4xl md:text-5xl  font-bold mb-4">
            Our Works
          </h1>
          <div className="flex items-center text-sm md:text-base space-x-2 text-gray-200">
            <Link to="/" className="hover:text-white cursor-pointer">
              Home
            </Link>
            <span>/</span>
            <Link to="/about" className="text-gray-300 hover:text-white cursor-pointer">
              Projects
            </Link>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className='flex flex-row items-center justify-between'>
            {/* Section Title */}
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
              Our Projects
            </h2>

          </div>

          {/* Projects Grid */}
          <div className="grid gap-8 md:grid-cols-3">
            {projects.map((project, index) => (
              <motion.div
                key={project.id}
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                whileHover={{ scale: 1.03 }}
                className="bg-white rounded-sm overflow-hidden group"
              >
                {/* Image */}
                <img
                  src={project.img}
                  alt={project.title}
                  loading="lazy"
                  className="w-full h-48 object-cover group-hover:scale-105 transition duration-500"
                />

                {/* Content */}
                <div className="p-6">
                  <p className="text-sm text-primary font-medium mb-1">
                    {project.category}
                  </p>
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">
                    {project.title}
                  </h3>
                  <div className="flex items-center justify-between text-gray-600 text-sm hover:text-primary cursor-pointer transition">
                    <Link to={`/projects/${project.title.replace(/\s+/g, "-").toLowerCase()}`}>
                      <span>Case Details</span>
                    </Link>
                    <FaArrowRight className="ml-2 text-sm" />
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

    </div>
  )
}

export default Projects
